export const getLocalStorageItem = (item: string) =>
  JSON.parse(localStorage.getItem(item));

export const setLocalStorageItem = (item: string, value: any) =>
  localStorage.setItem(item, JSON.stringify(value));

export const removeLocalStorageItem = (item: string) =>
  localStorage.removeItem(item);
